<template>
  <form-wizard ref="add_drivers_form" color="#39C0ED"  @on-complete="editConfirmation">
    <h2 slot="title"></h2>   
      <tab-content title="Registration" :before-change="()=>validateStep('childRegistrationComponent')">
        <regis-card  :driver.sync="driver" ref="childRegistrationComponent"/>
      </tab-content>
      <tab-content title="Identity" :before-change="()=>validateStep('childIdentityComponent')">
        <identity-card @data="dataIdentity" :driver="driver" ref="childIdentityComponent"/>
         
      </tab-content>
      <tab-content title="Driving License" :before-change="()=>validateStep('childLicenseComponent')">
        <license-card @data="dataLicense" :driver="driver" ref="childLicenseComponent"/>
      </tab-content>
      <tab-content title="Bank Account" :before-change="()=>validateStep('childBankComponent')">
        <bank-card @data="dataBank" :driver="driver" ref="childBankComponent"/>
      </tab-content>
 
  </form-wizard>
</template>
 
<script>
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

// import komponen
import RegisCard from "@/pages/Dashboard/Fms/Driver/ComponentForm/RegisCard.vue";
import IdentityCard from "@/pages/Dashboard/Fms/Driver/ComponentForm/IdentityCard.vue";
import LicenseCard from "@/pages/Dashboard/Fms/Driver/ComponentForm/LicenseCard.vue";
import BankCard from "@/pages/Dashboard/Fms/Driver/ComponentForm/BankCard.vue";
import Swal from 'sweetalert2';

//  extend('useppn', {
//   ...required,
//   message: 'Use PPN field is required'
//   });
//   extend('dealername', {
//     ...required,
//     message: 'Dealer Name field is required'
//   });

export default {
  name: "add-drivers",

  // props: {
  //   driver: Object,
  // },

  components: {
    // ValidationError,
    FormWizard,
    TabContent,
    "regis-card": RegisCard,
    "identity-card": IdentityCard,
    "license-card": LicenseCard,
    "bank-card": BankCard,
      
  },

  props: {
    data_id: null,
    },

  mixins: [formMixin],

  data: () => ({
    driver: [],
  }),
  
  created() {
    this.getDriverData();
  },
  
  methods: {
    async getDriverData(){
       if(this.data_id.id){
          
        //console.log(this.$route.params.id)
        //ambil data di server sesuai dengan data id yang ada di route
        await this.$store.dispatch("fms_driver/get", this.data_id.id)
        this.driver = await this.$store.getters["fms_driver/driver"]
        this.driver.driver_pool =  this.driver.driver_pool.id


        var self = this;
        setTimeout(function(){
          self.$refs.childRegistrationComponent.getDataParent()
          self.$refs.childIdentityComponent.getDataParent()
          self.$refs.childLicenseComponent.getDataParent()
          self.$refs.childBankComponent.getDataParent()

        }, 1);
       }
       else{
        //jika tidak ada kembali ke list
        await this.$router.replace({name: 'List Driver'});
      }
    },
    
    async editConfirmation() {
     
      Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be saved!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, save it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
      }).then((result) => {
        if (result.value){
          this.addDriver()
        }
      });
    },

    async closeEdit(){
      this.$parent.$parent.modalCloseEdit();
    },

    //fungsi untuk mengirim data ke server
    async addDriver() {
      //ambil data dari child page
      this.$refs.childIdentityComponent.getData()
      this.$refs.childLicenseComponent.getData()
      this.$refs.childBankComponent.getData()
      //set var data yang akan dikirm ke server
      const data = {
        type: "fms_drivers",
        id:this.driver.id,
        // driver_no: this.driver.driver_no,
        driver_name: this.driver.driver_name,
        driver_nickname: this.driver.driver_nickname,
        driver_pool: this.driver.driver_pool,
        // driver_type: this.driver.driver_type,
        driver_address: this.driver.driver_address,
        driver_email: this.driver.driver_email,
        driver_dp_id: this.driver.driver_dp_id,
        driver_place_of_birth_id: this.driver.driver_place_of_birth_id,
        // driver_business_unit_id: this.driver.driver_business_unit_id,
        driver_blacklist: this.driver.driver_blacklist,
        driver_place_of_birth: this.driver.driver_place_of_birth,
        driver_date_of_birth: this.driver.driver_date_of_birth,
        driver_gender: this.driver.driver_gender,
        driver_blood_type: this.driver.driver_blood_type,
        driver_religion: this.driver.driver_religion,
        driver_last_education: this.driver.driver_last_education,
        driver_phone_no: this.driver.driver_phone_no,
        driver_emergency_phone_no: this.driver.driver_emergency_phone_no,
        driver_balcklist: this.driver.driver_balcklist,
        driver_photo: this.driver.file_photo_driver,
        
        driver_license: this.driver.license,
        driver_identity : this.driver.identity,
        driver_bank: this.driver.bank
      }

      console.log(data)
      try {
        //kirim data ke server
      await this.$store.dispatch("fms_driver/update", data);
      //panggil alert succes
      await this.$store.dispatch(
        "alerts/success",
        "Successfully registered."
      );
      //kembali ke list
        this.$parent.$parent.modalCloseEdit();
      } catch (e) {
        //panggil alert error
        // await this.$store.dispatch(
        //   "alerts/error",
        //   "Oops, something went wrong"
        // );
        console.log(e);
        this.setApiValidation(e.response.data.errors);
      }

    },
    
    //set data yang diambil dari child client
    dataBank (value) {
      this.driver.bank = value
    },
      //set data yang diambil dari child info
    // dataRegis (value) {
    //   this.driver.keluhan = value
    // },

      //set data yang diambil dari child service
    dataLicense (value) {
      this.driver.license = value
    },
      //set data yang diambil dari child part
    dataIdentity (value) {
      console.log(value) 
      this.driver.identity = value
    },
    
    //checke validasi stiap child sebulum pindah section
    validateStep(name) {
      var refToValidate = this.$refs[name]
      return refToValidate.validateForm()
    },
    
  },
  mounted() {
    console.log('Component mounted.')
  }
};
</script>



